<div mat-dialog-content>
    <div class="row">
        <div class="col-md-12">
            <div class="card pb-0 mb-2">
                <div class="card-body pb-0">
                    <table class="mb-0 table table-hover">
                        <thead>
                            <tr>
                                <th>Passengers</th>
                                <th style="text-align: right;">Base Fare</th>
                                <th style="text-align: right;">Taxes</th>
                                <th style="text-align: right;">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="isAdult(flight)" [ngClass]="{'custom-prices':true}">
                                <th scope="row">Adult * {{ flight.Price.PassengerBreakup.ADT.PassengerCount }}</th>
                                <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.ADT.BasePrice *
                                    flight.Price.PassengerBreakup.ADT.PassengerCount | number:'1.0-0' }}
                                </td>
                                <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.ADT.Tax *
                                    flight.Price.PassengerBreakup.ADT.PassengerCount | number:'1.0-0'}}
                                </td>
                                <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.ADT.TotalPrice *
                                    flight.Price.PassengerBreakup.ADT.PassengerCount | number:'1.0-0'}}
                                </td>
                            </tr>
                            <tr *ngIf="isChild(flight)" [ngClass]="{'custom-prices':true}">
                                <ng-container *ngIf="childProp === 'CHD'">
                                    <th scope="row">Child * {{ flight.Price.PassengerBreakup.CHD.PassengerCount }}</th>
                                    <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.CHD.BasePrice *
                                        flight.Price.PassengerBreakup.CHD.PassengerCount }}
                                    </td>
                                    <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.CHD.Tax *
                                        flight.Price.PassengerBreakup.CHD.PassengerCount | number:'1.0-0' }}
                                    </td>
                                    <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.CHD.TotalPrice *
                                        flight.Price.PassengerBreakup.CHD.PassengerCount | number:'1.0-0' }}
                                    </td>
                                </ng-container>
                                <ng-container *ngIf="childProp === 'CNN'">
                                    <th scope="row">Child * {{ flight.Price.PassengerBreakup.CNN.PassengerCount }}</th>
                                    <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.CNN.BasePrice *
                                        flight.Price.PassengerBreakup.CNN.PassengerCount }}
                                    </td>
                                    <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.CNN.Tax *
                                        flight.Price.PassengerBreakup.CNN.PassengerCount | number:'1.0-0' }}
                                    </td>
                                    <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.CNN.TotalPrice *
                                        flight.Price.PassengerBreakup.CNN.PassengerCount | number:'1.0-0' }}
                                    </td>
                                </ng-container>
                                <ng-container *ngIf="childProp === 'C09'">
                                    <th scope="row">Child * {{ flight.Price.PassengerBreakup.C09.PassengerCount }}</th>
                                    <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.C09.BasePrice *
                                        flight.Price.PassengerBreakup.C09.PassengerCount }}
                                    </td>
                                    <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.C09.Tax *
                                        flight.Price.PassengerBreakup.C09.PassengerCount | number:'1.0-0' }}
                                    </td>
                                    <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.C09.TotalPrice *
                                        flight.Price.PassengerBreakup.C09.PassengerCount | number:'1.0-0' }}
                                    </td>
                                </ng-container>
                            </tr>
                            <tr *ngIf="isInfant(flight)" [ngClass]="{'custom-prices':true}">
                                <th scope="row">Infant * {{ flight.Price.PassengerBreakup.INF.PassengerCount }}</th>
                                <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.INF.BasePrice *
                                    flight.Price.PassengerBreakup.INF.PassengerCount }}
                                </td>
                                <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.INF.Tax *
                                    flight.Price.PassengerBreakup.INF.PassengerCount | number:'1.0-0' }}
                                </td>
                                <td>{{ flight.Price.Currency }} {{ flight.Price.PassengerBreakup.INF.TotalPrice *
                                    flight.Price.PassengerBreakup.INF.PassengerCount | number:'1.0-0' }}
                                </td>
                            </tr>

                            <tr [ngClass]="{'custom-prices':true}">
                                <td colspan="4">
                                    <b>Grand Total: {{ flight.Price.Currency }}
                                        {{ flight.Price.TotalDisplayFare | number:'1.0-0' }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4">
                                    <a href="javascript:void(0);" class=""
                                        (click)="getFareRule(flight.ResultToken,flight.booking_source)"
                                        [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic"> Fare Rules
                                    </a>
                                </td>
                            </tr>
                            <tr *ngIf="!isCollapsed">
                                <td colspan="4">
                                    <div class="" [collapse]="isCollapsed" [isAnimated]="true" class="">
                                        <p *ngIf="fareRuleData.length">
                                            <!-- {{ fareRuleData }} -->
                                        </p>
                                        <div class="rules_dropdown">
                                            <table *ngIf="fareRuleData.length">
                                                <tr *ngFor="let f of fareRuleData">
                                                    <div [innerHTML]="f.Description" style="border-bottom: 1px solid;">
                                                    </div>
                                                </tr>
                                            </table>
                                            <p *ngIf="noData">NO Data Found.</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>